export const LANGUAGE_MENU = {
  ACTION_TYPES: {
    onMenuClick: 'onMenuClick',
    onItemClick: 'onItemClick'
  },

  MENU_TYPE: {
    slim: 'slim',
    classic: 'classic',
    expand: 'expand'
  },

  KEYS: {
    common: 0,
    all: 1
  },

  EXPAND_DISPLAY_ITEMS: {
    mobile: 4,
    desktop: 5
  }
}